"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgPriorityLow = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props),
    React.createElement("rect", { width: 16, height: 16, fill: "#708DBE", rx: 4 }),
    React.createElement("path", { fill: "#fff", d: "m7.917 9.593 2.366-1.506a.25.25 0 0 1 .384.211v1.52a.5.5 0 0 1-.234.422l-2.25 1.433a.5.5 0 0 1-.536 0L5.4 10.24a.5.5 0 0 1-.233-.422v-1.52a.25.25 0 0 1 .384-.211zM7.917 5.795l2.366-1.506a.25.25 0 0 1 .384.211v1.52a.5.5 0 0 1-.234.422l-2.25 1.433a.5.5 0 0 1-.536 0L5.4 6.442a.5.5 0 0 1-.233-.422V4.5a.25.25 0 0 1 .384-.211z" })));
exports.default = SvgPriorityLow;
